import { render, staticRenderFns } from "./LoadRatePage.vue?vue&type=template&id=7dc22f18&scoped=true&"
import script from "./LoadRatePage.vue?vue&type=script&lang=js&"
export * from "./LoadRatePage.vue?vue&type=script&lang=js&"
import style0 from "./LoadRatePage.vue?vue&type=style&index=0&id=7dc22f18&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dc22f18",
  null
  
)

export default component.exports